import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './Global';
import { defaultTheme } from './themes';
export function DataripsStyleWrapper({ children, theme = defaultTheme, }) {
    return (React.createElement(ThemeProvider, { theme: theme },
        children,
        React.createElement(GlobalStyle, null)));
}
